import { useFormik } from 'formik'
import i18n from 'i18next'
import { useParams } from 'react-router-dom'
import { Row } from 'reactstrap'
import * as Yup from 'yup'
import agency from '../../../../api/agency/hooks'
import BreadCrumb from '../../../../Components/Common/BreadCrumb'
import AdminLoader from '../../Components/AdminLoader/AdminLoader'
import AgencyOfficeForm from '../../Components/AgencyOfficeForm/AgencyOfficeForm'
import { officeAgencyFieldDescription } from '../../Components/AgencyOfficeForm/officeAgencyFieldDescription'
import UploadPhoto from '../../Components/UploadPhoto/UploadPhoto'
import { DEFAULT_TRANSPARENCY } from '../../constants'
import { formatPhoneNumber } from '../../helpers'
import { officeValidation } from '../validateRules'

const defaultOfficeValues = {
    name: '',
    taxNumber: '',
    priority: null,
    phoneNumber: '',
    mobileNumber: '',
    email: '',
    websiteUrl: '',
    street: '',
    streetNumber: '',
    city: '',
    zipCode: '',
    country: '',
    agencyOfficeSync: false,
    description: '',
    logo: null,
    watermark: null,
    watermarkPosition: '',
    watermarkTransparency: DEFAULT_TRANSPARENCY,
}

const OfficeCreateEdit = () => {
    const { id } = useParams()
    const description = officeAgencyFieldDescription()

    const { data: office = {}, isLoading } = agency.GetAgencyOffice.useQuery(id)
    const { mutate: createUpdateAgencyOffice } = agency.CreateUpdateAgencyOffice.useMutation()

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: { ...defaultOfficeValues, ...(!isLoading ? office : {}) },
        validationSchema: Yup.object(officeValidation()),
        onSubmit: (values) => {
            const phoneNumber = formatPhoneNumber(values?.phoneNumber)
            const mobileNumber = formatPhoneNumber(values?.mobileNumber)

            const { id: officeId, ...data } = values

            createUpdateAgencyOffice({
                id: officeId,
                data: {
                    ...data,
                    mobileNumber: mobileNumber,
                    phoneNumber: phoneNumber,
                    watermarkTransparency: values.watermarkTransparency || DEFAULT_TRANSPARENCY,
                },
            })
        },
    })

    return isLoading ? (
        <AdminLoader />
    ) : (
        <Row>
            <BreadCrumb title={id ? `${i18n.t('page.edit')} ${formik?.values?.name}` : i18n.t('admin.createNewOffice')} />
            <UploadPhoto
                formik={formik}
                photoField={'logo'}
                imageUrl={formik?.values?.logo}
                firstName={formik?.values?.name}
                headline={formik?.values?.name}
                permission={description.officeLogo}
            />
            <AgencyOfficeForm formik={formik} isOffice={true} cancelButtonUrl={'/admin/office'} />
        </Row>
    )
}

export default OfficeCreateEdit
